import ActionTypeEnum from "../enums/ActionTypeEnum";
import Action from "../interfaces/Action";
import Cart from "../interfaces/cart/Cart";

export default function cartReducer(state: Cart | null = null, action: Action) {
    switch (action.type) {
        case ActionTypeEnum.CART_SET:
            return action.cart;
        case ActionTypeEnum.CART_CUSTOMER_EMAIL_SET:
            return {
                ...state,
                customer_email: action.email,
            };
        case ActionTypeEnum.CART_PREFERENCES_SET:
            return {
                ...state,
                preferences: action.preferences,
            };
        case ActionTypeEnum.CART_PREFERENCES_SET_PARTIALLY: {
            const existingPreferences = state ? state.preferences : {};

            return {
                ...state,
                preferences: {
                    ...existingPreferences,
                    ...action.preferences,
                },
            };
        }
        case ActionTypeEnum.CART_ADDRESS_SHIPPING_SET:
            return {
                ...state,
                shipping_address: action.address,
            };
        case ActionTypeEnum.CART_ADDRESS_BILLING_SET:
            return {
                ...state,
                billing_address: action.address,
            };
        case ActionTypeEnum.CART_CLEAR:
            return null;
        default:
            // Action isn't a cart action so return the state unchanged.
            // This is because all reducers are called when any action is dispatched.
            return state;
    }
}
